import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';

export interface IEntity {
    Name?: string;
    OrganizationNumber?: string;
    BusinessAddresses?: IBusinessAddress;
}

export interface IBusinessAddress {
    ZipCode?: string;
    City?: string;
    Addresses?: string[];
}

/** Maps the response from the custom Retail Server GetEntity operation. */
export class EntityExtensionClass implements IEntity {
    // @ts-ignore Retail proxy generated entity properties are initialized by the constructor.
    public Name: string;

    // @ts-ignore Retail proxy generated entity properties are initialized by the constructor.
    public OrganizationNumber: string;

    // @ts-ignore Retail proxy generated entity properties are initialized by the constructor.
    public BusinessAddresses: IBusinessAddress;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        this.Name = odataObject.Name;
        this.OrganizationNumber = odataObject.OrganizationNumber;

        if (!odataObject.BusinessAddresses) {
            // @ts-ignore Retail proxy entity classes use undefined for missing properties.
            this.BusinessAddresses = undefined;
        } else if (!odataObject.BusinessAddresses['@odata.type']) {
            this.BusinessAddresses = new BusinessAddressExtensionClass(odataObject.BusinessAddresses);
        } else {
            let className: string = odataObject.BusinessAddresses['@odata.type'];
            className = className.substr(className.lastIndexOf('.') + 1).concat('Class');
            if (EntityClasses[className]) {
                this.BusinessAddresses = new EntityClasses[className](odataObject.BusinessAddresses);
            }
        }
    }
}

export class BusinessAddressExtensionClass implements IBusinessAddress {
    // @ts-ignore Retail proxy generated entity properties are initialized by the constructor.
    public ZipCode: string;

    // @ts-ignore Retail proxy generated entity properties are initialized by the constructor.
    public City: string;

    // @ts-ignore Retail proxy generated entity properties are initialized by the constructor.
    public Addresses: string[];

    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        this.ZipCode = odataObject.ZipCode;
        this.City = odataObject.City;
        // @ts-ignore Retail proxy entity classes use undefined for missing properties.
        this.Addresses = undefined;
        if (odataObject.Addresses) {
            this.Addresses = [];
            for (let index = 0; index < odataObject.Addresses.length; index++) {
                // @ts-ignore Retail proxy entity classes use undefined for missing array values.
                this.Addresses[index] = odataObject.Addresses[index] || undefined;
            }
        }
    }
}
